<template>
    <div class="footerControll">
        <div class="text">
            <div class="word">主办单位：云南省工程建设技术经济室</div>
            <div class="word">电话：0871-64320643</div>
            <div class="word"><a
                href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action#/Integrated/index"
                style="text-decoration: none; color: #ffffff"
                target='_blank'
            >备案号：滇ICP备18001273号-1</a></div>
        </div>
        <div class="text">
            <div class="word">技术支持：昆明行列科技有限公司</div>
            <div class="word">电话：0871-63122229</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Foot'
};
</script>

<style lang="less" scoped>
.footerControll {
    width: 100%;
    background: #467cf8;
    height: 80px;
    padding-top: 15px;
    box-sizing: border-box;
    text-align: center;
    .text {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #fff;
        margin-top: 10px;
        &:first-child {
            margin-top: unset;
        }
        .word {
            margin-right: 20px;
        }
    }
}
</style>
